import { AddCustomer } from ".";
import AddBusinessDataInFirebase from "./Firebase/Business/AddBusinessDataInFirebase";
import AddCustomerDataInFirebase from "./Firebase/Customers/AddCustomerData";
import AddExpenseDataInFirebase from "./Firebase/Expense/AddExpenseDataInFirebase";
import AddInvoiceDataInFirebase from "./Firebase/Invoice/AddInvoiceDataInFirebase";
import AddItemDataInFirebase from "./Firebase/Items/AddItemDataInFirebase";
import AddProformaInvoiceDataInFirebase from "./Firebase/ProformaInvoice/AddProformaInvoiceDataInFirebase";
import AddQuotationDataInFirebase from "./Firebase/Quotation/AddQuotationDataInFirebase";
import AddSaleReturnDataInFirebase from "./Firebase/SaleReturn/AddSaleReturnDataInFirebase";

export const AddLocalDataToFirebase = async (state, dispatch, userId) => {
  const businessData = JSON.parse(localStorage.getItem("LOCAL_BUSINESSES")) || [];
  const invoicedata = JSON.parse(localStorage.getItem("LOCAL_INVOICES")) || [];
  const expensedata = JSON.parse(localStorage.getItem("LOCAL_EXPENSE")) || [];
  const salereturndata = JSON.parse(localStorage.getItem("LOCAL_SALE_RETURN")) || [];
  const customerdata = JSON.parse(localStorage.getItem("LOCAL_CUSTOMER")) || [];
  const itemdata = JSON.parse(localStorage.getItem("LOCAL_ITEM")) || [];
  const proformainvoicedata = JSON.parse(localStorage.getItem("LOCAL_PROFORMA_INVOICES")) || [];
  const quotationdata = JSON.parse(localStorage.getItem("LOCAL_QUOTATION")) || [];


  if (businessData.length > 0) {

    AddBusinessDataInFirebase(state, dispatch, businessData[0], userId, true);

    if (invoicedata.length > 0) {
      if (Array.isArray(invoicedata) && invoicedata.length > 0) {
        invoicedata.forEach((invoice) => {
          AddInvoiceDataInFirebase(state, dispatch, invoice, userId);
        });
      } else {
        console.error("No valid invoice data found in localStorage.");
      }
    }

    if (expensedata.length > 0) {
      if (Array.isArray(expensedata) && expensedata.length > 0) {
        expensedata.forEach((expense) => {
          AddExpenseDataInFirebase(state, dispatch, expense, userId);
        });
      } else {
        console.error("No valid expense data found in localStorage.");
      }
    }

    if (salereturndata.length > 0) {
      if (Array.isArray(salereturndata) && salereturndata.length > 0) {
        salereturndata.forEach((salereturn) => {
          AddSaleReturnDataInFirebase(state, dispatch, salereturn, userId);
        });
      } else {
        console.error("No valid salereturn data found in localStorage.");
      }
    }

    if (customerdata.length > 0) {
      if (Array.isArray(customerdata) && customerdata.length > 0) {
        const islocal = true;
        customerdata.forEach((customerdata) => {
          AddCustomerDataInFirebase(state, dispatch, customerdata, userId, islocal);
        });
      } else {
        console.error("No valid customer data found in localStorage.");

      }
    }
  }
  if (itemdata.length > 0) {
    const islocal = true;
    if (Array.isArray(itemdata) && itemdata.length > 0) {
      AddItemDataInFirebase(state, dispatch, itemdata, userId, islocal);
    } else {
      console.error("No valid customer data found in localStorage.");

    }

  }
  if (quotationdata.length > 0) {
    if (Array.isArray(quotationdata) && quotationdata.length > 0) {
      quotationdata.forEach((quotation) => {
        AddQuotationDataInFirebase(state, dispatch, quotation, userId);
      });
    } else {
      console.error("No valid invoice data found in localStorage.");
    }
  }
  if (proformainvoicedata.length > 0) {
    if (Array.isArray(proformainvoicedata) && proformainvoicedata.length > 0) {
      proformainvoicedata.forEach((proformainvoice) => {
        AddProformaInvoiceDataInFirebase(state, dispatch, proformainvoice, userId);
      });
    } else {
      console.error("No valid invoice data found in localStorage.");
    }
  }
};